import { ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'

interface ConfirmationModalProps {
  open?: boolean
  title?: ReactNode
  text?: ReactNode
  okText?: ReactNode
  cancelText?: ReactNode
  onOk?: () => void
  onCancel?: () => void
}

export default function ConfirmationModal({
  open,
  title,
  text,
  okText,
  cancelText,
  onOk,
  onCancel
}: ConfirmationModalProps) {
  return (
    <Dialog
      open={!!open}
      onOpenChange={(next) => {
        if (!next) onCancel?.()
      }}
    >
      <DialogContent>
        <DialogHeader>
          {title && <DialogTitle>{title}</DialogTitle>}
          {text && <DialogDescription>{text}</DialogDescription>}
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghostDark" onClick={() => onCancel?.()}>
            {cancelText ?? 'Zrušiť'}
          </Button>
          <Button type="button" onClick={() => onOk?.()}>
            {okText ?? 'OK'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
